export enum DataTableSortType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export class SortModel {
  constructor(
      public sortBy: string,
      public sortOrder: string
  ) { }
}

export class Paging {
  size: number;
  number: number;
  totalPages: number;
  numberOfElements: number;
  sort: SortModel;
  sortDefault: SortModel;
  totalElements: number;

  constructor(size?: number, number?: number, sortBy?: string, sortOrder: DataTableSortType = DataTableSortType.ASC) {
      this.size = size == null ? 25 : size;
      this.number = number == null ? 0 : number;
      this.setDefaultSort(sortBy, sortOrder);
  }

  setDefaultSort(sortBy: string, sortOrder: DataTableSortType) {
      this.sort = new SortModel(sortBy, sortOrder);
      this.sortDefault = new SortModel(sortBy, sortOrder);
  }
}

export class RequestOption {
  filter?: any;
  pagingOptions?: Paging;

  constructor() {
      this.filter = {};
      this.pagingOptions = new Paging();
  }
}

export class BaseModel {
  createDate?: number;
  createBy?: string;
  updateDate?: number;
  updateBy?: string;
}
